import { AnyAction } from 'redux';

interface LinkModel {
    href: string;
    text: string;
}

export interface PagesState {
    myPage: LinkModel;
    currentCategoryUrl: string;
}

const defaultState: PagesState = {
    myPage: {
        href: '',
        text: '',
    },
    currentCategoryUrl: ''
};

export const pages = (
    state = defaultState,
    action: AnyAction
): PagesState => {
    const { type, payload } = action;
    switch (type) {
        default:
            return state;
    }
};
